export const instanceTransformer = data => ({
  id: data.idinstancia,
  name: {
    es: data.nombreEs,
    eu: data.nombreEu
  }
})

export const transformInstances = data =>
  data.map(item => instanceTransformer(item))